import { compare } from 'vscode/vscode/vs/base/common/strings';
import { LanguageFeatureRegistry } from 'vscode/vscode/vs/editor/common/languageFeatureRegistry';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';

class LanguageStatusServiceImpl {
    constructor() {
        this._provider = ( new LanguageFeatureRegistry());
        this.onDidChange = this._provider.onDidChange;
    }
    addStatus(status) {
        return this._provider.register(status.selector, status);
    }
    getLanguageStatus(model) {
        return this._provider.ordered(model).sort((a, b) => {
            let res = b.severity - a.severity;
            if (res === 0) {
                res = compare(a.source, b.source);
            }
            if (res === 0) {
                res = compare(a.id, b.id);
            }
            return res;
        });
    }
}

export { LanguageStatusServiceImpl };
